'use client';
import { Fragment } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { IconButton } from '../../buttons';
import { Dialog, Modal, ModalOverlay } from 'react-aria-components';

export interface DefaultModalProps {
  title?: string;
  isOpen: boolean;

  onClose(): void;

  afterLeave?: () => void;
  unmount?: boolean;
  children: React.ReactNode;
}

export function DefaultModal({
  title,
  isOpen = false,
  onClose,
  afterLeave,
  unmount,
  children,
}: DefaultModalProps) {
  return (
    <ModalOverlay
      isOpen={isOpen}
      onOpenChange={(isOpen) => !isOpen && onClose()}
      className="fixed inset-0 transition-opacity bg-black/30 z-[60] outline-0"
    >
      <Modal className="outline-0">
        <Dialog
          className="fixed inset-0 z-50 flex items-center justify-center outline-0"
          aria-label={title}
        >
          <div
            className="flex justify-center items-center p-4 md:p-6"
            style={{ fontSize: 0 }}
          >
            <Fragment>
              <div className="flex text-base text-left transform transition w-[calc(100vw-2rem)] max-w-xl">
                <div className="w-full h-full flex flex-col bg-white shadow-xl overflow-hidden overflow-y-scroll scrollbar-hide p-4 md:p-6 max-h-[95svh] rounded-lg">
                  {title && (
                    <div className="border-b border-neutral-40 pb-4 md:pb-6">
                      <div className="flex items-center justify-between">
                        <h3 className="hd-md -mb-1.5">{title}</h3>
                        <div className="ml-3 h-7 flex items-center">
                          <IconButton
                            size="md"
                            onClick={onClose}
                            className="mr-2"
                            variant="ghost-muted"
                          >
                            <span className="sr-only">Lukk</span>
                            <XMarkIcon className="h-4 w-4" aria-hidden="true" />
                          </IconButton>
                        </div>
                      </div>
                    </div>
                  )}
                  {!title && (
                    <div className="flex justify-end items-center min-h-[4rem] max-h-screen overflow-scroll">
                      <IconButton
                        size="md"
                        onClick={onClose}
                        className="mr-5"
                        variant="ghost-muted"
                      >
                        <span className="sr-only">Lukk</span>
                        <XMarkIcon className="h-4 w-4" aria-hidden="true" />
                      </IconButton>
                    </div>
                  )}
                  {children}
                </div>
              </div>
            </Fragment>
          </div>
        </Dialog>
      </Modal>
    </ModalOverlay>
  );
}

export default DefaultModal;
